import React from 'react';

export default function Moos() {
    return (
        <div class="moos">
            <h1>Da Moos</h1>
            <ul>
                <li class="moositem">
                    Cow equities rally as American families substitute Thanksgiving
                    turkey with beef instead.
                </li>
                <li class="moositem">
                    US President decides to pardon a cow due to ongoing turkey shortage.
                </li>
                <li class="moositem">
                    Can the modern American family survive turkeyless Thanksgiving?
                    Experts are skeptical.
                </li>
                <li class="moositem">
                    Largest turkey producers across the world file for bankruptcy
                    after failing to recover from the Great Turkey Crash of 2021.
                </li>
                <li class="moositem">
                    President of Turkey announces that country name unrelated
                    to animal. Stock for Butterball, LLC and other turkey
                    producers go into freefall as turkey investors panic.
                </li>
                <li class="moositem">
                    Harry Potter and the Chamber of Cow smash hit with fans.
                </li>
                <li class="moositem">
                    Cow Media founded by entrepreneur with weird obsession with
                    cows.
                </li>
            </ul>
        </div>
    );
}